import Chat from "../utils/chat.js";

class ChatUI {
    constructor() {
        this.shadowRoot = null;
        this.container = null;
        this.isVisible = false;
        this.unreadCount = 0;
        this.messages = []; // Store messages with their IDs
        this.isVisible = false;
        this.unreadCount = 0;
        this.messages = []; // Store messages with their IDs
    }

    init(shadowRoot) {
        this.shadowRoot = shadowRoot;
        this.render();
        this.attachEventListeners();
        this.loadHistory();
    }

    render() {
        this.container = document.createElement("div");
        this.container.className = "chat-container hidden";
        this.container.innerHTML = `
            <div class="chat-header">
                <div class="chat-title">
                    <span class="chat-icon">💬</span>
                    <span>Proctor Chat</span>
                </div>
                <button class="chat-close-btn" aria-label="Close chat">×</button>
            </div>
            <div class="chat-messages" id="chat-messages">
                <!-- Messages will be inserted here -->
                <div class="chat-empty-state">No messages yet.</div>
            </div>
            <div class="chat-input-area">
                <textarea class="chat-input" placeholder="Type a message..." rows="1"></textarea>
                <button class="chat-send-btn" disabled>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
                    </svg>
                </button>
            </div>
        `;

        this.shadowRoot.appendChild(this.container);
    }

    attachEventListeners() {
        const closeBtn = this.container.querySelector(".chat-close-btn");
        const sendBtn = this.container.querySelector(".chat-send-btn");
        const input = this.container.querySelector(".chat-input");

        closeBtn.addEventListener("click", () => this.hide());

        sendBtn.addEventListener("click", () => this.sendMessage());

        input.addEventListener("input", () => {
            sendBtn.disabled = !input.value.trim();
            // Auto-resize textarea
            input.style.height = "auto";
            input.style.height = Math.min(input.scrollHeight, 100) + "px";
        });

        input.addEventListener("keydown", (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                this.sendMessage();
            }
        });
    }

    toggle() {
        if (this.isVisible) {
            this.hide();
        } else {
            this.show();
        }
    }

    addMessage(message, isSelf = false) {
        const messagesContainer = this.container.querySelector(".chat-messages");
        const emptyState = this.container.querySelector(".chat-empty-state");

        if (emptyState) {
            emptyState.remove();
        }

        const messageEl = document.createElement("div");
        messageEl.className = `chat-message ${isSelf ? "self" : "other"}`;

        const time = new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

        messageEl.innerHTML = `
            <div class="message-content">${this.escapeHtml(message.message)}</div>
            <div class="message-meta">
                ${time}
            </div>
        `;
        messageEl.dataset.messageId = message._id || message.id;

        messagesContainer.appendChild(messageEl);
        this.scrollToBottom();

        if (!this.isVisible && !isSelf) {
            this.unreadCount++;
            this.updateUnreadIndicator();
        }
    }

    async sendMessage() {
        const input = this.container.querySelector(".chat-input");
        const sendBtn = this.container.querySelector(".chat-send-btn");
        const text = input.value.trim();

        if (!text) return;

        try {
            input.disabled = true;
            sendBtn.disabled = true;

            // Optimistic UI update
            const tempMessage = {
                message: text,
                timestamp: new Date().toISOString(),
            };
            this.addMessage(tempMessage, true);

            input.value = "";
            input.style.height = "auto";

            await Chat.sendMessage(text);
        } catch (error) {
            console.error("Failed to send message:", error);
            // Show error state (could add a toast notification here)
        } finally {
            input.disabled = false;
            sendBtn.disabled = false;
            input.focus();
        }
    }

    async loadHistory() {
        try {
            // Skip loading if Chat hasn't been initialized yet
            // Chat.init() is called in ProctoringSDK.start() after the exam session starts
            if (!Chat.attemptId) {
                return;
            }
            const history = await Chat.getHistory(50);
            const messagesContainer = this.container.querySelector(".chat-messages");
            messagesContainer.innerHTML = ""; // Clear existing
            this.messages = []; // Clear stored messages

            if (history.length === 0) {
                messagesContainer.innerHTML = '<div class="chat-empty-state">No messages yet.</div>';
                return;
            }

            // Sort by timestamp if needed (API returns reverse chron usually, need chron for display)
            // Assuming API returns [newest, ..., oldest] or [oldest, ..., newest]
            // Let's verify sort order. Controller returns: messages.reverse() which implies Oldest -> Newest.

            history.forEach(msg => {
                const isSelf = msg.senderRole === "user"; // Assuming 'user' is the student role
                this.addMessage(msg, isSelf);
            });
        } catch (err) {
            console.error("Failed to load chat history", err);
        }
    }

    async markAsRead() {
        this.unreadCount = 0;
        this.updateUnreadIndicator();
    }

    updateUnreadIndicator() {
        // Find or create badge on camera preview (handled by UI class usually,
        // but we can emit an event or update a shared DOM element)
        // For now, let's dispatch a custom event that UI.js can listen to
        const event = new CustomEvent('chat-unread-change', {
            detail: { count: this.unreadCount }
        });
        window.dispatchEvent(event);
    }

    scrollToBottom() {
        const messagesContainer = this.container.querySelector(".chat-messages");
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    getStatusIcon(status) {
        return '';
    }

    async show() {
        this.container.classList.remove("hidden");
        this.isVisible = true;
        this.scrollToBottom();
        await this.markAsRead();
        this.isVisible = true;
        this.scrollToBottom();
        await this.markAsRead();

        // Focus input
        setTimeout(() => {
            const input = this.container.querySelector(".chat-input");
            input?.focus();
        }, 100);
    }

    hide() {
        this.container.classList.add("hidden");
        this.isVisible = false;
        this.isVisible = false;
    }

    destroy() {

        this.container?.remove();
        this.container = null;
    }
}

export default new ChatUI();
